import http from '../../http'
let list = (data) => {
    return http.post('opservice/group/page', data)
}
let list1 = (data) => {
  return http.post('opservice/group/without/count/page', data)
}
let gudingList = (data) => {
  return http.get('opservice/group/list', data)
}
export default {
    list,
    list1,
    gudingList,//固定组
    get: (params) => {
        return http.get('opservice/group/get', params)
    }, //根据ID查询用户
    save: (params) => {
        return http.post('opservice/group/upsert', params)
    }, //保存或更新用户分组信息
    del: (params) => {
        return http.post('opservice/group/delete', params)
    }, //删除用户分组(支持批量）
    userlist: (params) => {
        return http.post('opservice/group/listuser', params)
    }, //根据ID查询用户
}
